import cartDataNotLoggedHtml from './cartdatanotlogged.component.html';
import './cartdatanotlogged.component.scss';

class CartDataNotLoggedController {
    constructor($scope, CartService, $sce) {
        'ngInject';
        this.$scope = $scope;
        this.service = CartService;
        this.$sce = $sce;
        this.countries = window.countries || ['Polska'];
    }

    $onInit() {
        this.service.step = 2;
        this.$scope.$watch(
            () => {
                if (!this.service.loaded || !this.service.summary) return null;

                return this.service.summary.country;
            },
            (newVal, oldVal) => {
                this.service.data.shipmentAddress.country = newVal;
            }
        );
        this.$scope.$watch(
            () => {
                if (!this.service.summary) return null;

                return this.service.summary;
            },
            (newSummary, oldSummary) => {
                if (!newSummary) return;
                if (!this.service.loaded || this.service.loading) return;

                // New cart value -> refresh payments and shipments
                if (!oldSummary || (oldSummary && newSummary.value_of_products_with_discount != oldSummary.value_of_products_with_discount)) {
                    this.service.loadPayments();

                    if (newSummary.payment_id) {
                        this.service.loadShipments();
                    }

                    return;
                }

                if (oldSummary && newSummary.payment_id && newSummary.payment_id != oldSummary.payment_id) {
                    this.service.loadShipments();
                }
            },
            true
        );
        this.$scope.$watch(
            () => {
                if (!this.service.summary) return null;

                return this.service.summary;
            },
            (newSummary, oldSummary) => {
                if (newSummary && newSummary.merge_order_email) {
                    this.service.data.shipmentAddress.email = newSummary.merge_order_email;
                }
            }
        );
    }
}

let cartDataNotLoggedComponent = {
    bindings: {},
    template: cartDataNotLoggedHtml,
    controller: CartDataNotLoggedController
}

export default cartDataNotLoggedComponent;
